import { voidfallChapters } from './content';
export const voidfallGlossary = voidfallChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('GLOSSARY'));
